

//       reader.onload = () => {

//       className={`border-2 border-dashed border-input rounded-lg p-8 ${isDragging ? "bg-gray-100" : ""
//       onDragOver={!disable ? handleDragOver : null}
//       onDragLeave={!disable ? handleDragLeave : null}
//       onDrop={!disable ?  handleDrop : null}
//         accept={format ? format : ".jpg, .jpeg, .png, .pdf"}
//         <div className="w-full h-36 overflow-hidden border-input rounded-lg border-2 bg-uploadImg">
//               className={`w-12 h-12 mx-auto mb-4 text-gray-500 ${!disable ? "cursor-pointer" : "cursor-not-allowed"}`}
//               viewBox="0 0 49 38"
//               onClick={!disable ? handleChooseFile : null}
//                 d="M40.4927 12.6436C38.2742 3.80599 29.3117 -1.55986 20.4741 0.65858C13.5677 2.3923 8.55291 8.36136 8.03622 15.4632C3.13241 16.2719 -0.187381 20.9027 0.621312 25.8065C1.3402 30.1661 5.11773 33.3588 9.53605 33.3412H17.0352V30.3416H9.53605C6.22273 30.3416 3.53671 27.6555 3.53671 24.3422C3.53671 21.0289 6.22273 18.3429 9.53605 18.3429C10.3644 18.3429 11.0359 17.6714 11.0359 16.843C11.0284 9.388 17.0659 3.33841 24.5209 3.33101C30.9743 3.32454 36.5296 7.88685 37.778 14.2183C37.8381 14.5266 37.9934 14.8083 38.2222 15.0236C38.4509 15.2388 38.7414 15.3769 39.0528 15.4182C43.1532 16.0021 46.0037 19.7994 45.4199 23.8997C44.8956 27.5816 41.752 30.323 38.0329 30.3416H32.0336V33.3412H38.0329C43.8313 33.3237 48.5175 28.609 48.4999 22.8106C48.4853 17.9839 45.1815 13.789 40.4927 12.6436Z"
//                 d="M23.4696 18.778L17.4702 24.7773L19.585 26.8921L23.0346 23.4575V37.8409H26.0343V23.4575L29.4689 26.8921L31.5837 24.7773L25.5843 18.778C24.9993 18.1964 24.0546 18.1964 23.4696 18.778Z"
//                 onClick={!disable ? handleChooseFile : null}
//                 className={`text-primaryText font-semibold focus:outline-none ${!disable ? "cursor-pointer" : "cursor-not-allowed"}`}
//               <span className="text-f12 text-secondary block">
//                 Supported format : {format ? (format.slice(1)).toUpperCase() : "JPG, JPEG, PNG, PDF"}

import React, { useEffect, useRef, useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Button } from "./Button";

export const UploadingInput = ({
  onFileSelect,
  uploadError,
  uploadedFile,
  format,
  disable,
  clear,
  width = "",
  height = "",
}) => {
  const fileInputRef = useRef();

  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [showCropModal, setShowCropModal] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  useEffect(() => {
    if (uploadedFile == null) {
      setPreviewUrl(null);
    }
  }, [uploadedFile]);

  useEffect(() => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [clear]);

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error) => reject(error));
      image.setAttribute("crossOrigin", "anonymous");
      image.src = url;
    });

  const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, "image/jpeg");
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (width && height && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    } else {
      handleNormalUpload(file);
    }
  };

  const handleNormalUpload = (file) => {
    onFileSelect(file);

    if (file && file.type.startsWith("image/")) {
      const objectUrl = URL.createObjectURL(file);
      setPreviewUrl(objectUrl);
    }
  };

  const handleCropSave = async () => {
    const croppedBlob = await getCroppedImg(
      imageToCrop,
      croppedAreaPixels
    );

    const croppedFile = new File([croppedBlob], "cropped.jpeg", {
      type: "image/jpeg",
    });

    const objectUrl = URL.createObjectURL(croppedFile);
    setPreviewUrl(objectUrl);

    onFileSelect(croppedFile);

    setShowCropModal(false);
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleChooseFile = () => {
    if (!disable) {
      fileInputRef.current.click();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const file = e.dataTransfer.files[0];
    if (!file) return;

    if (width && height && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    } else {
      handleNormalUpload(file);
    }
  };

  return (
    <>
      <div
        className={`border-2 border-dashed border-input rounded-lg p-8 ${
          isDragging ? "bg-gray-100" : ""
        } ${disable ? "cursor-not-allowed" : "cursor-default"}`}
        onDragOver={!disable ? handleDragOver : null}
        onDragLeave={!disable ? handleDragLeave : null}
        onDrop={!disable ? handleDrop : null}
      >
        <input
          type="file"
          accept={format ? format : ".jpg,.jpeg,.png,.pdf"}
          onChange={handleFileChange}
          ref={fileInputRef}
          className="hidden"
          disabled={disable}
        />

        {previewUrl ? (
          <div className="w-full h-36 overflow-hidden rounded-lg border-2 bg-uploadImg flex items-center justify-center">
            <img
              src={previewUrl}
              alt="Preview"
              className="max-h-full object-contain"
            />
          </div>
        ) : (
          <div className="text-center">
            <p className="text-sm">
              Drag & Drop or{" "}
              <button
                type="button"
                onClick={handleChooseFile}
                className="text-blue-600 font-semibold"
                disabled={disable}
              >
                Select file
              </button>{" "}
              to upload
            </p>
            <span className="text-xs text-gray-500 block mt-1">
              Supported format:{" "}
              {format
                ? format.replace(/\./g, "").toUpperCase()
                : "JPG, JPEG, PNG, PDF"}
            </span>
          </div>
        )}
      </div>

      {/* CROP MODAL */}
      {showCropModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg w-[500px]">
            <div className="relative w-full h-[400px]">
              <Cropper
                image={imageToCrop}
                crop={crop}
                zoom={zoom}
                aspect={width / height}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>

            <div className="mt-4">
              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e) => setZoom(e.target.value)}
                className="w-full"
              />
            </div>

            <div className="flex justify-end gap-3 mt-4">
              <button
                className="px-4 py-2 bg-gray-300 rounded"
                onClick={() => setShowCropModal(false)}
              >
                Cancel
              </button>

              <Button
                className="px-4 py-2 rounded text-primaryText font-semibold focus:outline-none"
                onClick={handleCropSave}
              >
                Crop & Save
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
